import React from 'react'
import { Avatar, Box } from '@mui/material';
import { Routes, Route } from "react-router-dom";
import MyToolBar from '../components/MyToolBar';
import { useSelector } from "react-redux";
import logo from './logo.png'
import logosm from './logosm.png'
import logoyw from './yellow_white_logo.png'
import { useLocation } from 'react-router-dom';
import './layout.css';
import SideBar from './SideBar';
import ErrorBoundary from '../components/ErrorBoundary';
import PackageExpiryBanner from '../components/PackageExpiryBanner';

export default function Layout(props) {
    let user = useSelector((state) => state?.loginState?.auth)
    const [toggled, setToggled] = React.useState(false);
    const [isMinimize, setIsMinimize] = React.useState(false);
    const [broken, setBroken] = React.useState(window.matchMedia('(max-width: 800px)').matches);
    const location = useLocation();
    const currentPath = location.pathname.replace(/\/+$/, '') || '/';
    let hideProps = props?.menus?.find(item => (item?.to?.replace(/\/+$/, '') || '/') === currentPath) || {};

    React.useEffect(() => {
        setToggled(!broken)
    }, [])

    React.useEffect(() => {
        window.scrollTo(0, 0);
        if (document.documentElement) document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
        const mainEl = document.querySelector('[name="main"]');
        if (mainEl) mainEl.scrollTop = 0;
    }, [location.pathname]);

    const makePermittedMenu = (menu, permissions) => {
        if (menu?.owner?.includes(user?.main_role)) { menu.label = menu.changeText }
        if (menu?.hide) return undefined
        if (menu?.adminOnly && !user?.is_superuser && !["SuperAdmin", "Admin"].includes(user?.main_role)) return undefined
        if (menu?.permission && !permissions.includes("*") && !permissions.includes(menu?.permission)) return undefined
        return menu
    }
    // ispushsidebar
    const createMenu = () => {
        let routers = []
        let permissions = (user?.permissions || []).map((permission) => typeof permission === 'string' ? permission.split(".")[1] || permission : permission)
        if (props?.info) {
            console.info("Permissions", permissions)
        }
        if (!permissions.includes('*')) { permissions.push("*") }

        return [props?.menus?.map((menu, j) => {
            routers.push(menu)
            routers.push(...menu?.submenus || [])
            let pmenu = makePermittedMenu(menu, permissions)
            if (!pmenu) return undefined
            let submenus = pmenu?.submenus?.map((submenu, i) => {
                return makePermittedMenu(submenu, permissions)
            })
            pmenu.submenus = submenus?.filter((submenu) => submenu != undefined) || []
            return pmenu
        })?.filter(Boolean) || [], routers]
    }
    const [permittedMenu, routers] = createMenu()

    const Margin = (hideBar) => {
        let body = <>
            {!hideProps.hideSideBar && <SideBar menus={permittedMenu} />}
            <Box name="main" sx={{ width: 1 }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%', /* Make the container take up the full viewport height */
                    paddingTop: hideProps.hideHeader ? '0px' : '60px'
                }}>
                    <PackageExpiryBanner user={user} />
                    <Box sx={{ flex: '1 1 auto', borderRadius: 0 }}>
                        <Routes>
                            {(() => {
                                const seenPaths = new Set();
                                const routes = [];
                                const registerRoute = (path, component) => {
                                    if (!path || !component) return;
                                    const norm = path === '/' ? '/' : path.replace(/\/+$/, '');
                                    if (!seenPaths.has(norm)) {
                                        seenPaths.add(norm);
                                        routes.push(
                                            <Route
                                                key={norm}
                                                path={norm}
                                                element={<ErrorBoundary>{component}</ErrorBoundary>}
                                            />
                                        );
                                        if (norm !== '/') {
                                            seenPaths.add(norm + '/');
                                            routes.push(
                                                <Route
                                                    key={norm + '/'}
                                                    path={norm + '/'}
                                                    element={<ErrorBoundary>{component}</ErrorBoundary>}
                                                />
                                            );
                                        }
                                    }
                                };

                                (routers || []).forEach((submenu) => {
                                    if (!submenu) return;
                                    if (submenu.to && submenu.component) {
                                        registerRoute(submenu.to, submenu.component);
                                    }
                                    if (Array.isArray(submenu.proxyto)) {
                                        submenu.proxyto.forEach((proxyto) => {
                                            if (proxyto?.to && proxyto?.component) {
                                                registerRoute(proxyto.to, proxyto.component);
                                            }
                                        });
                                    } else if (submenu?.proxyto?.to && submenu?.proxyto?.component) {
                                        registerRoute(submenu.proxyto.to, submenu.proxyto.component);
                                    }
                                });

                                return routes;
                            })()}
                        </Routes>
                    </Box>
                </Box >


            </Box>
        </>

        if (hideBar) return body
        return <Box>
            <Box sx={{ flex: '0 0 auto' }}>
                {!hideProps.hideHeader && <>
                    <MyToolBar logo={logo} logosm={logosm} logoyw={logoyw} appName={props?.appName} user={user} onToggled={() => { setToggled(!toggled); setIsMinimize(!isMinimize) }} onLogout={props.onLogout} />
                </>}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'stretch' }} gap={0}>
                {body}
            </Box>
        </Box >
    }
    return (
        <>
            {Margin(hideProps.hideSideBar && hideProps.hideHeader)}
        </>
    )

}